import { render, staticRenderFns } from "./EmailSend.vue?vue&type=template&id=ee2891a0&scoped=true&"
import script from "./EmailSend.vue?vue&type=script&lang=js&"
export * from "./EmailSend.vue?vue&type=script&lang=js&"
import style0 from "./EmailSend.vue?vue&type=style&index=0&id=ee2891a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2891a0",
  null
  
)

export default component.exports